/** @flow */

// Non authenticated paths
export const HOME_PATH = "/";
export const REGISTRATION_PATH = "/registration";
export const PASSWORD_SET_PATH = "/password/set";
export const NOT_FOUND_PATH = "/not-found";
export const ACCESS_DENIED_PATH = "/access-denied";
export const SERVICE_UNAVAILABLE_PATH = "/service-unavailable";
export const NO_ACCESS_PATH = "/no-access";
export const SILENT_CHECK_SSO_HTML = ":domain/silent-check-sso.html";
export const PRINT_PAGE = ":domain/print";

// Authenticated paths
export const FAIRPROCESSING_PATH = "https://www.goodshape.com/fairprocessing";

// Product and Services
export const GOODSHAPE_PRODUCTS_URL = "/goodshape-products";
export const SERVICE_HUB_URL = "/service-hub";
export const SERVICE_DESK_URL = "/service-desk";

export const APP_PROMOTION_PATH = "/goodshape-app";
export const MY_ABSENCES_PATH = "/my-absences";
export const ADVICE_LIBRARY_PATH = "/advice-library";
export const SERVICE_DIRECTORY_PATH = "/service-directory";

// Client
export const ADMINISTRATION_PATH = "/administration";
export const ADMINISTRATION_CLIENT_PATH = "/administration/client";
export const ADMINISTRATION_CLIENT_DETAILS_PATH = "/administration/client/:clientId/client-details";
export const ADMINISTRATION_SLA_PERFORMANCE_PATH =
  "/administration/client/:clientId/sla-performance";

// Data
export const ADMINISTRATION_DATA_PAGE_PATH = "/administration/data/:clientId/data";
export const ADMINISTRATION_DATA_ADMIN_ARCHIVE_PATH =
  "/administration/data/:clientId/data-admin/archive"; // looks like not used

// Hierarchy
export const ADMINISTRATION_HIERARCHY_ADMIN_PATH =
  "/administration/hierarchy/:clientId/hierarchy-admin";
export const ADMINISTRATION_HIERARCHY_CHANGES_PATH =
  "/administration/hierarchy/:clientId/hierarchy-changes";
export const ADMINISTRATION_HIERARCHY_CHANGE_LOG_PATH =
  "/administration/hierarchy/:clientId/change-history";

// Service
export const ADMINISTRATION_SERVICE_SETTINGS = "/administration/service/:clientId/general/settings";
export const ADMINISTRATION_SERVICE_SECURITY =
  "/administration/service/:clientId/security/security-settings";
export const ADMINISTRATION_SERVICE_DEPARTMENT_SPECIFIC_SCRIPT_DETAILS =
  "/administration/service/:clientId/prompts/department-script/:scriptId";
export const ADMINISTRATION_SERVICE_STANDARD_QUESTION_DETAILS =
  "/administration/service/:clientId/features/standart-questions/:standardQuestionId";

export const ADMINISTRATION_SERVICE_FEATURES_ABSENCE_REASONS =
  "/administration/service/:clientId/features#absenceReasons";

export const ADMINISTRATION_SERVICE_FEATURES_ALERTS =
  "/administration/service/:clientId/features#alerts";

export const ADMINISTRATION_SERVICE_FEATURES_QUESTIONS =
  "/administration/service/:clientId/features#questions";

export const ADMINISTRATION_SERVICE_FEATURES_RTW_FORM =
  "/administration/service/:clientId/features#rtwforms";

export const ADMINISTRATION_SERVICE_FEATURES_SHIFT_PATTERNS =
  "/administration/service/:clientId/features#shiftPatterns";

export const ADMINISTRATION_SERVICE_FEATURES_MONITOR =
  "/administration/service/:clientId/features#monitor";

export const ADMINISTRATION_SERVICE_FEATURES_NAVIGATOR =
  "/administration/service/:clientId/features#navigator";

export const ADMINISTRATION_SERVICE_DYNAMIC_QUESTION_DETAILS =
  "/administration/service/:clientId/features/dynamic-questions/:dynamicQuestionId";
export const ADMINISTRATION_SERVICE_WELLBEING_SERVICES =
  "/administration/service/:clientId/wellbeing-services";
export const ADMINISTRATION_SERVICE_NOTIFICATIONS_PAGE =
  "/administration/service/:clientId/notifications";
export const ADMINISTRATION_CLIENT_FEATURES_PATH = "/administration/service/:clientId/features";
export const ADMINISTRATION_SERVICE_EVENT_DETAILS =
  "/administration/service/:clientId/features/alerts/:alertId";

export const ADMINISTRATION_SERVICE_RETURN_TO_WORK_DETAILS =
  "/administration/service/:clientId/features/return-to-work/:processId";

export const ADMINISTRATION_SERVICE_ABSENCE_MONITORING_DETAILS =
  "/administration/service/:clientId/features/absence-monitoring/:processId";
export const ADMINISTRATION_SERVICE_REFERRAL_DETAILS =
  "/administration/service/:clientId/features/referral/:processId";
export const ADMINISTRATION_SERVICE_REASON_SPECIFIC_SCRIPT_DETAILS =
  "/administration/service/:clientId/prompts/reason-script/:scriptId";
export const ADMINISTRATION_SERVICE_USERS = "/administration/service/:clientId/security/users";
export const ADMINISTRATION_SERVICE_EXISTING_USERS =
  "/administration/service/:clientId/security/users#existingusers";

export const ADMINISTRATION_CLIENT_AUDIT_LOGS_PATH = "/administration/service/:clientId/audit-logs";

// Employee
export const ADMINISTRATION_EMPLOYEE_MY_DETAILS = "/administration/employee/my-details";

// Reporting
export const REPORTING_PATH = "/reporting";
export const REPORTING_DATA_FORECASTS_PATH = "/reporting/:clientId/forecast";
export const REPORTING_DASHBOARD_PATH = "/reporting/:clientId/dashboard";
export const REPORTING_TOOLS_ACTIVITYFEED_PATH = "/reporting/:clientId/activityfeed";
export const REPORTING_TOOLS_CORONAVIRUS_PATH = "/reporting/:clientId/coronavirus";
export const REPORTING_TOOLS_INDEX_PATH = "/reporting/:clientId/index";

export const REPORTING_TASKS_FULL_PATH = "/reporting/:clientId/tasks/:taskId?/:taskType?";
export const REPORTING_TOOLS_TASKS_PATH = "/reporting/:clientId/tasks";
export const REPORTING_MY_NOTIFICATIONS_PATH = "/reporting/:clientId/notifications";
export const REPORTING_REPORTS_OVERVIEW_PATH = "/reporting/:clientId/reports/overview";
export const REPORTING_REPORTS_ABSENCE_DETAILS_PATH =
  "/reporting/:clientId/reports/absence-details";
export const REPORTING_REPORTS_ABSENCE_DETAILS_REPORT_PATH =
  "/reporting/:clientId/reports/absence-details/report";
export const REPORTING_TOOLS_NOTIFICATION = "/reporting/:clientId/notifications";
export const REPORTING_REPORTS_ABSENCE_MONITORING_PATH =
  "/reporting/:clientId/reports/absence-monitoring";
export const REPORTING_ABSENCE_MONITORING_DETAILS_REPORT =
  "/reporting/:clientId/reports/absence-monitoring/report";
export const REPORTING_REPORTS_RTW_DETAILS_PATH = "/reporting/:clientId/reports/rtw-details";
export const REPORTING_RTW_DETAILS_REPORT = "/reporting/:clientId/reports/rtw-details/report";
export const REPORTING_REPORTS_ALERT_DETAILS_PATH = "/reporting/:clientId/reports/alert-details";
export const REPORTING_ALERT_DETAILS_REPORT = "/reporting/:clientId/reports/alert-details/report";
export const REPORTING_REFERRAL_DETAILS_REPORT = "/reporting/:clientId/reports/referral/report";
export const REPORTING_REPORTS_ALERT_DETAILS = "/reporting/:clientId/reports/alert-details";
export const REPORTING_FOCUS_LISTS_EMPLOYEE_PATH = "/reporting/:clientId/focus-lists/employee";
export const REPORTING_FOCUS_LISTS_EMPLOYEE_REPORT =
  "/reporting/:clientId/focus-lists/employee/report";
export const REPORTING_FOCUS_LISTS_DEPARTMENT_PATH = "/reporting/:clientId/focus-lists/department";
export const REPORTING_FOCUS_LISTS_DEPARTMENT_REPORT =
  "/reporting/:clientId/focus-lists/department/report";
export const REPORTING_FOCUS_LISTS_MANAGER_PATH = "/reporting/:clientId/focus-lists/manager";
export const REPORTING_FOCUS_LISTS_MANAGER_REPORT =
  "/reporting/:clientId/focus-lists/manager/report";
export const REPORTING_TRENDS_ABSENCE_RATE_PATH = "/reporting/:clientId/trends/absence-rate";
export const REPORTING_TRENDS_ABSENCE_RATE_REPORT =
  "/reporting/:clientId/trends/absence-rate/report";
export const REPORTING_TRENDS_ABSENCE_REASON_PATH = "/reporting/:clientId/trends/absence-reason";
export const REPORTING_TRENDS_ABSENCE_REASON_REPORT_PATH =
  "/reporting/:clientId/trends/absence-reason/report";
export const REPORTING_TRENDS_COMPLIANCE_PATH = "/reporting/:clientId/trends/compliance";
export const REPORTING_TRENDS_COMPLIANCE_REPORT = "/reporting/:clientId/trends/compliance/report";

// Reporting -> Employees
export const REPORTING_EMPLOYEES_SEARCH_PATH = "/reporting/:clientId/employees/search";
export const REPORTING_EMPLOYEES_AUDIT_EMPLOYEE_DETAILS =
  "/reporting/:clientId/employees/search/audit/:employeeId";
export const REPORTING_EMPLOYEE_DETAILS_PATH = "/reporting/:clientId/employees/:employeeId/details";
export const REPORTING_EMPLOYEE_STATISTICS_PATH =
  "/reporting/:clientId/employees/:employeeId/statistics";
export const REPORTING_EMPLOYEE_ABSENCE_NOTES_PATH =
  "/reporting/:clientId/employees/:employeeId/absence-notes";
export const REPORTING_EMPLOYEE_DOCUMENTS_PATH =
  "/reporting/:clientId/employees/:employeeId/documents";
export const REPORTING_EMPLOYEE_ACCOUNT_PATH =
  "/reporting/:clientId/employees/:employeeId/details#admin";
export const REPORTING_EMPLOYEE_MONITORING_PATH =
  "/reporting/:clientId/employees/:employeeId/monitoring";
export const REPORTING_EMPLOYEE_ABSENCES_PATH =
  "/reporting/:clientId/employees/:employeeId/details#absences";
export const REPORTING_EMPLOYEE_ABSENCE_DETAILS_PATH =
  "/reporting/:clientId/employees/:employeeId/details/absences/:absenceId";
export const REPORTING_EMPLOYEE_ABSENCE_DETAILS_REVISION_PATH =
  "/reporting/:clientId/employees/:employeeId/details/absences/:absenceId/revision/:revisionId";
export const REPORTING_EMPLOYEE_NOTIFICATIONS_PATH =
  "/reporting/:clientId/employees/:employeeId/details#contacts";

export const REPORTING_EMPLOYEE_EMPLOYEE_ADMIN =
  "/reporting/:clientId/employees/:employeeId/employee-admin";
export const REPORTING_EMPLOYEES_EXPORT = "/reporting/:clientId/employees/:employeeId/export";
export const REPORTING_EMPLOYEE_FORECASTS_PATH =
  "/reporting/:clientId/employees/:employeeId/forecasts";
export const REPORTING_MI_PRESENTATIONS_PATH = "/reporting/:clientId/mi-presentations";
export const REPORTING_EMPLOYEE_REFERRALS = "/reporting/:clientId/employees/:employeeId/referrals";
export const REPORTING_EMPLOYEE_WELLBEING_REFERRALS =
  "/reporting/:clientId/employees/:employeeId/wellbeing-referrals";
export const REPORTS_KPI_COMPLIANCE_PATH = "/reporting/:clientId/reports/kpi-compliance";

// Profile
export const PROFILE_MY_DETAILS = "/user/profile/my-details";
export const PROFILE_MY_EMPLOYEES = "/user/profile/my-employees";

// Help
export const HELP_PATH = "/help";
export const HELP_QUESTION_PATH = "/help/:questionId";

// Mobile App
export const MOBILE_APP_PATH = "/mobile-app";

// Health Reports
export const REPORTING_HEALTH_OVERVIEW_PATH = "/reporting/:clientId/health-overview";
export const REPORTING_WORKFORCE_HEALTH_PATH = "/reporting/:clientId/work-force-health";
export const REPORTING_CARE_PLANS_PATH = "/reporting/:clientId/care-plans";
export const REPORTING_WELLBEING_ADVICE_PATH = "/reporting/:clientId/wellbeing-advice";
export const REPORTING_NURSE_ASSESSMENTS_PATH = "/reporting/:clientId/nurse-assessments";

// Providers Reports
export const REPORTING_PROVIDERS_REPORT_PATH = "/reporting/:clientId/providers";

// Navigator
export const REPORTING_REFERRALS_OVERVIEW = "/reporting/:clientId/referrals-overview";
export const REPORTING_NEW_REFERRALS = "/reporting/:clientId/new-referrals";
export const REPORTING_ACTIVE_REFERRALS = "/reporting/:clientId/active-referrals";
export const REPORTING_CLOSED_REFERRALS = "/reporting/:clientId/closed-referrals";
export const REPORTING_OUTCOMES_REPORT = "/reporting/:clientId/outcomes";
export const REPORTING_MANAGER_KPI = "/reporting/:clientId/manager-kpi";
